import { colors } from '@components/shared'

export function getColor (name?: string): string {
  switch (name) {
    case 'romance':
      return colors.orange
    case 'wellness':
      return colors.creamsicle
    case 'relationships':
      return colors.pink
    case 'culture':
      return colors.sand
    case 'Dipsea':
      return colors.white
    default:
      return colors.white
  }
}
